/**
 * Time to Connect — the Grandstream-only KPI on Alert Details
 * (docs/TIME_TO_CONNECT_PLAN.md).
 *
 * The report Lambda computes it (attachTimeToConnect in serverless/mysql_report.py)
 * and puts `time_to_connect` (minutes to the first intercom call, null when the
 * alert had none) and `intercom_used` (bool) on each row, plus
 * `avg_time_to_connect` (intercom alerts only, null when there were none) and
 * `intercom_usage_pct` (intercom alerts / all alerts) on the summary. This file
 * only holds what the page shows about it.
 *
 * Operations rule (2026-10-09): alerts without an intercom call are left out of
 * the average and shown as N/A, never 0 and never their response time.
 */

/** Columns that exist only for Grandstream campuses (core_campus.is_grandstream). */
export const GRANDSTREAM_ONLY_COLUMNS = ['calls', 'time_to_connect'];

/** What an alert with no intercom call shows for Time to Connect. */
export const TIME_TO_CONNECT_NA = 'N/A';

/* One constant on purpose. "Answered" holds even though core_event_calls has no
   answered flag yet: the intercom speakers auto-answer (no answer button), so a
   placed call (call_length > 0) to a speaker connects. The rare exception is a
   call the PBX forwards to voicemail (user, 2026-10-10; plan, "Follow-up"). */
export const TIME_TO_CONNECT_INFO =
    'Time from the alert to the first answered intercom call to the resident or their room. '
    + 'Only alerts where the intercom was used are included; the rest show N/A and are left out '
    + 'of the average.';

export const INTERCOM_USAGE_INFO =
    'Share of all alerts where the intercom was used. Counted per alert, so several calls on '
    + 'one alert count once.';

/**
 * An Avg Time to Connect figure (headline card or one hour): '-' when it wasn't
 * computed (keys absent: the connect lookup failed), N/A when there were no
 * intercom alerts (present but null), else the minutes.
 */
export function formatAvgTimeToConnect(computed, value) {
    if (!computed) return '-';
    return value == null || value === '' ? TIME_TO_CONNECT_NA : value;
}

/** Display label for a row's intercom_used. */
export function intercomUsedLabel(used) {
    if (used === true) return 'Yes';
    if (used === false) return 'No';
    return '';
}
